import React from 'react'
import VehicleBasedIntegrations from '../vehicleBasedIntegrations/VehicleBasedIntegrations'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'

const Logisystems: React.FC = () => {
  const integrationDocs = useIntegrationDocsURL()

  return (
    <VehicleBasedIntegrations
      allowAuthentication={false}
      credentialsRequestUrl="/logisystems/authentication/{companyId}"
      getVehiclesUrl="/logisystems/vehicles/{companyId}"
      updateVehicleUrl="/logisystems/vehicles/{companyId}/{id}"
      pageDocsUrl={integrationDocs.external('logisystems')}
      name="logisystems"
    />
  )
}

export default Logisystems
